// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"9ea4a71a","27":"9d6fb7fb","98":"5a577b74","188":"ff832ea6","224":"11099bfa","292":"101c47a7","418":"9a797367","498":"b810bd09","513":"4226b6f9","638":"77cc7afc","703":"7d4fdcd5"}[chunkId] + ".chunk.js";
};